import { render, staticRenderFns } from "./warehouse.vue?vue&type=template&id=42a08c2c&scoped=true"
import script from "./warehouse.vue?vue&type=script&setup=true&lang=js"
export * from "./warehouse.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a08c2c",
  null
  
)

export default component.exports